import { useAppInfo } from '~/hooks/useAppInfo'

import { IdentificationNumberBR } from './BR'
import { GenericIdentificationNumber } from './Generic'
import { IdentificationNumberPE } from './PE'

export const IdentificationNumber = () => {
  const { country } = useAppInfo()

  const defaultComponent = GenericIdentificationNumber

  const Component =
    {
      BR: IdentificationNumberBR,
      PE: IdentificationNumberPE,
      default: defaultComponent
    }?.[country] ?? defaultComponent

  return <Component />
}
